export default __webpack_public_path__ + "static/media/dudu_badge_1.dc32369e.svg";